
import { Vue, Component, PropSync, Prop, Watch } from "vue-property-decorator";
import { filterStructure } from "@/models/entities/storage/storageInput/storageInput.interface";
@Component
export default class rowNavigationDrawer extends Vue {
  @Prop({
    required: true,
    default: () => {
      return [];
    },
  })
  private items: filterStructure[];
  @Prop({ required: false, default: false }) private checkActivity: boolean;

  @PropSync("model") value;
  @Prop({ required: false }) private rules: Array<undefined>;
  @Prop({ required: false }) private label: string;
  //common
  @Prop({ required: false, default: 12 }) private cols: number;
  @Prop({ required: false, default: false }) private Secondary: boolean;
  @Prop({ required: false, default: false }) private disabled: boolean;
  //secondo
  @Prop({
    required: false,
    default: () => {
      return [];
    },
  })
  private itemsSecondary: filterStructure[];
  @PropSync("modelSecondary") valueSecondary;
  @Prop({ required: false }) private rulesSecondary: Array<undefined>;
  @Prop({ required: false }) private labelSecondary: string;

  @Watch("items")
  itemsChanged(): void {
    if (!this.disabled) {
      if (this.items != null && this.items.length > 0) {
        if (this.items != null && this.items.length === 1) {
          this.setDefaultSingleValue();
        }
      }
    }
  }
  @Watch("itemsSecondary")
  itemsSecondaryChanged(): void {
    if (!this.disabled) {
      if (this.items != null && this.items.length > 0) {
        if (this.itemsSecondary != null && this.itemsSecondary.length > 0) {
          // this.setDefaultMultipleValue();
        } else {
          // this.setDefaultSingleValue();
        }
      }
    }
  }

  private setDefaultSingleValue(): void {
    if (this.items != null && this.items.length == 1) {
      this.value = this.items[0].value;
    }
  }

  private setDefaultMultipleValue(): void {
    if (
      this.items != null &&
      this.items.length > 0 &&
      this.itemsSecondary != null &&
      this.itemsSecondary.length > 0
    ) {
      this.value = this.items[0].value;
      this.valueSecondary =
        this.itemsSecondary[this.itemsSecondary.length - 1].value;
    }
  }

  private resetFilters(): void {
    if (this.checkActivity) {
      this.$emit("resetFilters", false);
    }
  }
}
